import { gql } from "@apollo/client";

const GET_MY_SETTINGS = gql`
  query GetMySettings {
    me {
      savedLevels {
        id
        languageId
      }
      locale
      currentLevel {
        id
      }
      preferClassType
      charactersPreference
      spokenOnly
      timeZone
      timeFormat
      notificationMethod
      remindNextClass
      remindRateClass
      sendTips
      currentLanguage {
        id
      }
    }
    levels {
      id
      title
    }
    locales {
      code
      language
    }
    timeZones {
      name
      nameWithOffset
    }
  }
`;

export default GET_MY_SETTINGS;
